import { PUBLIC_CREATOR_ROUTE_PREFIXES } from "./posthog.constants";

export function isPublicCreatorRoute(pathname?: string | null): boolean {
  if (!pathname) return false;
  const rawLower = pathname.toLowerCase();
  let decodedLower = rawLower;
  try {
    decodedLower = decodeURIComponent(pathname).toLowerCase();
  } catch {
    // If malformed URI, fallback to rawLower
  }
  return PUBLIC_CREATOR_ROUTE_PREFIXES.some(
    (prefix) =>
      rawLower.startsWith(prefix) || decodedLower.startsWith(prefix),
  );
}

export function shouldDisablePostHogFeatureFlags(
  pathname?: string | null,
  isAuthenticated = false,
): boolean {
  return isPublicCreatorRoute(pathname) && !isAuthenticated;
}
